export const attributeSegment = v => {
    if (!v) return '';
    let segments = JSON.parse(localStorage.getItem('segments'));
    const segment = segments.find((segment) => segment.value === v);
    if (!segment) return '';
    return segment.text;
}

export const attributeColor = v => {
    if (!v) return '';
    let colors = JSON.parse(localStorage.getItem('colors'));
    const color = colors.find((color) => color.value === v);
    if (!color) return '';
    return color.text;
}

export const attributeCategory = v => {
    if (!v) return '';
    let categories = JSON.parse(localStorage.getItem('categories'));
    const category = categories.find((category) => category.value === v);
    if (!category) return '';
    return category.text;
}

export const attributeCollection = v => {
    if (!v) return '';
    let collections = JSON.parse(localStorage.getItem('collections'));
    const collection = collections.find((collection) => collection.value === v);
    if (!collection) return '';
    return collection.text;
}

export const attributeFinishing = v => {
    if (!v) return '';
    let finishings = JSON.parse(localStorage.getItem('finishings'));
    const finishing = finishings.find((finishing) => finishing.value === v);
    if (!finishing) return '';
    return finishing.text;
}

export const attributeGender = v => {
    if (!v) return '';
    let genders = JSON.parse(localStorage.getItem('genders'));
    const gender = genders.find((gender) => gender.value === v);
    if (!gender) return '';
    return gender.text;
}

export const attributeGrid = v => {
    if (!v) return '';
    let grids = JSON.parse(localStorage.getItem('grids'));
    const grid = grids.find((grid) => grid.value === v);
    if (!grid) return '';
    return grid.text;
}

export const attributeLine = v => {
    if (!v) return '';
    let lines = JSON.parse(localStorage.getItem('lines'));
    const line = lines.find((line) => line.value === v);
    if (!line) return '';
    return line.text;
}

export const attributeThickness = v => {
    if (!v) return '';
    let thicknesses = JSON.parse(localStorage.getItem('thicknesses'));
    const thickness = thicknesses.find((thickness) => thickness.value === v);
    if (!thickness) return '';
    return thickness.text;

}

export const attributeMaterial = v => {
    if (!v) return '';
    let materials = JSON.parse(localStorage.getItem('materials'));
    const material = materials.find((material) => material.value === v);
    if (!material) return '';
    return material.text;
}


export const attributeGroup = v => {
    if (!v) return '';
    let groups = JSON.parse(localStorage.getItem('groups'));
    const group = groups.find((group) => group.value === v);
    if (!group) return '';
    return group.text;
}

export const attributeSubgroup = v => {
    if (!v) return '';
    let subgroups = JSON.parse(localStorage.getItem('subgroups'));
    const subgroup = subgroups.find((subgroup) => subgroup.value === v);
    if (!subgroup) return '';
    return subgroup.text;
}

export const attributeSaleschannel = v => {
    if (!v) return '';
    let saleschannels = JSON.parse(localStorage.getItem('saleschannels'));
    const saleschannel = saleschannels.find((saleschannel) => saleschannel.value === v);
    if (!saleschannels) return '';
    return saleschannel.text;
}

export const attributeSector = v => {
    if (!v) return '';
    let sectors = JSON.parse(localStorage.getItem('sectors'));
    const sector = sectors.find((sector) => sector.value === v);
    if (!sector) return '';
    return sector.text;
}

export const attributeClassification = v => {
    if (!v) return '';
    let classifications = JSON.parse(localStorage.getItem('classifications'));
    const classification = classifications.find((classification) => classification.value === v);
    if (!classification) return '';
    return classification.text;
}

export const attributeMeasurement = v => {
    if (!v) return '';
    let measurements = JSON.parse(localStorage.getItem('measurements'));
    const measurement = measurements.find((measurement) => measurement.value === v);
    if (!measurement) return '';
    return measurement.text;
}


export const attributeGuarantee = v => {
    if (!v) return '';
    let guarantees = JSON.parse(localStorage.getItem('guarantees'));
    const guarantee = guarantees.find((guarantee) => guarantee.value === v);
    if (!guarantee) return '';
    return guarantee.text;
}

export const attributeClass = v => {
    if (!v) return '';
    let classes = JSON.parse(localStorage.getItem('classes'));
    const _class = classes.find((_class) => _class.value === v);
    if (!_class) return '';
    return _class.text;
}

export const attributeDestination = v => {
    if (!v) return '';
    let destinies = JSON.parse(localStorage.getItem('destinies'));
    const destiny = destinies.find((destiny) => destiny.value === v);
    if (!destiny) return '';
    return destiny.text;
}

export const attributeCoin = v => {
    if (!v) return '';
    let coins = JSON.parse(localStorage.getItem('coins'));
    const coin = coins.find((destiny) => destiny.value === v);
    if (!coin) return '';
    return coin.symbol;
}

export const attributeCoinName = v => {
    if (!v) return '';
    let coins = JSON.parse(localStorage.getItem('coins'));
    const coin = coins.find((destiny) => destiny.value === v);
    if (!coin) return '';
    return coin.name;
}

